import React from 'react';
import { NavLink } from 'react-router-dom';
import GLOBAL_CONFIG from '../../../config/config';
import appGoogleTracking from '../../../modules/googletracking';

const GiftContentFooter = (props) => { 

    let btnContent = null,
        { btnShow, hrShow, classModifier, options } = props;

    if((!!props.options && props.options.btnShow === true) || btnShow){
        btnContent = (
            <NavLink to={GLOBAL_CONFIG.Route.home} exact data-event="go_to_milka_homepage" data-category="Thank You Page" data-action="Go to page" data-label="MILKA_OTHER_TYP" onClick={appGoogleTracking.processEventCTANavLink}>
                <div className="btn__container btn--secondary-lilac btn--hover">
                    <span className="btn__text">Zurück zur Startseite</span>
                </div>
            </NavLink>
        );   
    }

    let classname = ((!!props.options && props.options.hrShow === true) || hrShow) ? 'content-gift-footer hr' : 'content-gift-footer';

    return (
        <div className={!!classModifier ? `${classname} ${classModifier}` : classname}>
            {btnContent}
            <div className="content-faq s-content-copy marge-bottom">
                <div className="s-content-copy__item footer">
                    <p className="headings">HAST DU NOCH FRAGEN ZUM GEWINNSPIEL?</p>
                    
                    
                    {window.location.pathname.toLowerCase() === GLOBAL_CONFIG.Route.home.toLowerCase() ? (
                        <p style={{ fontSize: '20px', marginTop: '25px' }}>
                            <NavLink to={GLOBAL_CONFIG.Route.faq} target="_blank" exact data-event="go_to_faq_link" data-category="Start Page" data-action="Click on Link" data-label="GAME_SP_FORM" onClick={appGoogleTracking.processEventCTANavLink}>
                                Hier
                            </NavLink> geht's zu den FAQ.
                        </p>
                    ) : window.location.pathname.toLowerCase() === GLOBAL_CONFIG.Route.thankyou.toLowerCase() ? (
                        <p style={{ fontSize: '20px', marginTop: '25px' }}>
                            <NavLink to={GLOBAL_CONFIG.Route.faq} target="_blank" exact data-event="go_to_faq_link" data-category="Confirmation Page" data-action="Click on Link" data-label="ENG_CP_OTHER" onClick={appGoogleTracking.processEventCTANavLink}>
                                Hier
                            </NavLink> geht's zu den FAQ.
                        </p>
                    ) : window.location.pathname.toLowerCase() === GLOBAL_CONFIG.Route.gewinne.toLowerCase() ? (
                        <p style={{ fontSize: '20px', marginTop: '25px' }}>
                            <NavLink to={GLOBAL_CONFIG.Route.faq} target="_blank" exact data-event="go_to_faq_link" data-category="Start Page" data-action="Click on link" data-label="ENG_SP_OTHER" onClick={appGoogleTracking.processEventCTANavLink}>
                                Hier
                            </NavLink> geht's zu den FAQ.
                        </p>
                    ) : (
                        <p style={{ fontSize: '20px', marginTop: '25px' }}>
                            <NavLink to={GLOBAL_CONFIG.Route.faq} target="_blank" exact data-event="go_to_faq_link" data-category="Start Page" data-action="Click on link" data-label="ENG_SP_OTHER" onClick={appGoogleTracking.processEventCTANavLink}>
                                Hier
                            </NavLink> geht's zu den FAQ.
                        </p>
                )}
                </div>
            </div>
        </div>
    );
}

export default GiftContentFooter;
